const fi = {
  // ============================================================
  // COMMON — Shared across the entire application
  // ============================================================
  common: {
    loading: 'Ladataan...',
    error: 'Virhe',
    save: 'Tallenna',
    cancel: 'Peruuta',
    delete: 'Poista',
    edit: 'Muokkaa',
    create: 'Luo',
    add: 'Lisää',
    remove: 'Poista',
    close: 'Sulje',
    confirm: 'Vahvista',
    apply: 'Käytä',
    reset: 'Palauta',
    search: 'Hae',
    filter: 'Suodata',
    clear: 'Tyhjennä',
    back: 'Takaisin',
    next: 'Seuraava',
    previous: 'Edellinen',
    submit: 'Lähetä',
    update: 'Päivitä',
    refresh: 'Päivitä',
    export: 'Vie',
    import: 'Tuo',
    download: 'Lataa',
    upload: 'Lataa palvelimelle',
    print: 'Tulosta',
    copy: 'Kopioi',
    yes: 'Kyllä',
    no: 'Ei',
    ok: 'OK',
    done: 'Valmis',
    select: 'Valitse',
    selectAll: 'Valitse kaikki',
    deselectAll: 'Poista valinnat',
    noResults: 'Tuloksia ei löytynyt',
    noData: 'Tietoja ei saatavilla',
    required: 'Pakollinen',
    optional: 'Valinnainen',
    actions: 'Toiminnot',
    details: 'Tiedot',
    overview: 'Yleiskatsaus',
    summary: 'Yhteenveto',
    total: 'Yhteensä',
    all: 'Kaikki',
    none: 'Ei mitään',
    name: 'Nimi',
    type: 'Tyyppi',
    status: 'Tila',
    date: 'Päivämäärä',
    time: 'Aika',
    description: 'Kuvaus',
    notes: 'Huomautukset',
    comments: 'Kommentit',
    category: 'Kategoria',
    priority: 'Prioriteetti',
    nation: 'Maa',
    country: 'Valtio',
    email: 'Sähköposti',
    phone: 'Puhelin',
    address: 'Osoite',
    location: 'Sijainti',
    coordinates: 'Koordinaatit',
    latitude: 'Leveysaste',
    longitude: 'Pituusaste',
    from: 'Alkaen',
    to: 'Asti',
    createdAt: 'Luotu',
    updatedAt: 'Päivitetty',
    createdBy: 'Luonut',
    modifiedBy: 'Muokannut',
    active: 'Aktiivinen',
    inactive: 'Ei aktiivinen',
    enabled: 'Käytössä',
    disabled: 'Pois käytöstä',
    showing: 'Näytetään',
    of: '/',
    page: 'Sivu',
    perPage: 'sivulla',
    rows: 'riviä',
    items: 'kohdetta',
    results: 'tulosta',
    sortBy: 'Järjestä',
    ascending: 'Nouseva',
    descending: 'Laskeva',
    viewAll: 'Näytä kaikki',
    viewDetails: 'Näytä tiedot',
    goBack: 'Palaa takaisin',
    learnMore: 'Lue lisää',
    seeMore: 'Näytä lisää',
    showMore: 'Näytä enemmän',
    showLess: 'Näytä vähemmän',
    expandAll: 'Laajenna kaikki',
    collapseAll: 'Supista kaikki',
    copied: 'Kopioitu!',
    saved: 'Tallennettu!',
    deleted: 'Poistettu!',
    updated: 'Päivitetty!',
    created: 'Luotu!',
    success: 'Onnistui',
    warning: 'Varoitus',
    info: 'Tiedoksi',
    danger: 'Vaara',
    unknown: 'Tuntematon',
    notAvailable: 'Ei saatavilla',
    never: 'Ei koskaan',
    today: 'Tänään',
    yesterday: 'Eilen',
    tomorrow: 'Huomenna',
    now: 'Nyt',
    ago: 'sitten',
    justNow: 'juuri nyt',
    minutesAgo: '{{count}} min sitten',
    hoursAgo: '{{count}} t sitten',
    daysAgo: '{{count}} pv sitten',
    monthsAgo: '{{count}} kk sitten',
    id: 'ID',
    version: 'Versio',
    language: 'Kieli',
    theme: 'Teema',
    darkMode: 'Tumma tila',
    lightMode: 'Vaalea tila',
    failedToLoad: 'Tietojen lataaminen epäonnistui',
    failedToSave: 'Tallentaminen epäonnistui',
    failedToDelete: 'Poistaminen epäonnistui',
    failedToUpdate: 'Päivittäminen epäonnistui',
    confirmDelete: 'Haluatko varmasti poistaa tämän?',
    confirmAction: 'Oletko varma?',
    unsavedChanges: 'Sinulla on tallentamattomia muutoksia. Haluatko varmasti poistua?',
    pageNotFound: '404 – Sivua ei löytynyt',
    pageNotFoundDesc: 'Etsimääsi sivua ei ole olemassa.',
    backToDashboard: 'Takaisin hallintapaneeliin',
    characters: 'merkkiä',
    maxCharacters: 'Enintään {{max}} merkkiä',
    remaining: '{{count}} jäljellä',
    selected: '{{count}} valittu',
    of_total: '{{count}} / {{total}}',
    utcHint: 'All times are in UTC',
    utcStoredHint: 'Times are stored in UTC in the database',
  },

  // ============================================================
  // NAVIGATION — Header, sidebar, menus
  // ============================================================
  nav: {
    dashboard: 'Hallintapaneeli',
    requests: 'Pyynnöt',
    transports: 'Kuljetukset',
    myPatients: 'Omat potilaat',
    statistics: 'Tilastot',
    flow: 'Virtaus',
    resources: 'Resources',
    exercise: 'Harjoitus',
    administration: 'Hallinta',
    map: 'Kartta',
    info: 'Tiedot',
    users: 'Käyttäjät',
    assets: 'Resurssit',
    hubs: 'Solmupisteet',
    treatmentFacilities: 'Hoitolaitokset',
    patientImport: 'Potilastuonti',
    assetTemplates: 'Resurssimallit',
    dayTemplates: 'Päivämallit',
    announcementTicker: 'Tiedotenauha',
    exerciseStatistics: 'Harjoitustilastot',
    settings: 'Asetukset',
    auditLog: 'Tarkastusloki',
    exerciseControl: 'Harjoituksen hallinta',
    dataSync: 'Tietojen synkronointi',
    documentation: 'Dokumentaatio',
    support: 'Tuki',
    about: 'Tietoja',
    assetContracts: 'Asset Contracts',
    notifications: 'Ilmoitukset',
    schedules: 'Aikataulut',
    capacityPlanning: 'Kapasiteettisuunnittelu',
    transportPlanning: 'Kuljetussuunnittelu',
    transportBooking: 'Kuljetusvaraus',
    flowDiagram: 'Virtauskaavio',
    changePassword: 'Vaihda salasana',
    missions: 'Tehtävät',
    startPoints: 'Lähtöpisteet',
    hospital: 'Sairaala',
  },

  // ============================================================
  // AUTH — Login, password, session
  // ============================================================
  auth: {
    login: 'Kirjaudu sisään',
    logout: 'Kirjaudu ulos',
    logoutNow: 'Kirjaudu ulos nyt',
    loggingIn: 'Kirjaudutaan...',
    loginFailed: 'Kirjautuminen epäonnistui',
    email: 'Sähköposti',
    password: 'Salasana',
    username: 'Käyttäjänimi',
    enterEmail: 'Syötä sähköpostiosoitteesi',
    enterPassword: 'Syötä salasanasi',
    enterUsername: 'Syötä käyttäjänimesi',
    forgotPassword: 'Unohditko salasanan?',
    forgotPasswordTitle: 'Unohtunut salasana',
    forgotPasswordDesc: 'Syötä käyttäjänimesi ja sähköpostiosoitteesi. Jos molemmat täsmäävät, ylläpitäjiä ilmoitetaan salasanan nollaamisesta.',
    requestPasswordReset: 'Pyydä salasanan nollaus',
    sending: 'Lähetetään...',
    backToLogin: 'Takaisin kirjautumiseen',
    pleaseWait: 'Odota ennen uutta yritystä.',
    requestFailed: 'Pyyntö epäonnistui',
    credentialsMatch: 'Jos tunnistetiedot täsmäävät, ylläpitäjiä on ilmoitettu.',
    forAccess: 'Pääsyoikeuksia varten ota yhteyttä järjestelmänvalvojaan.',
    changePassword: 'Vaihda salasana',
    currentPassword: 'Nykyinen salasana',
    newPassword: 'Uusi salasana',
    confirmPassword: 'Vahvista salasana',
    passwordChanged: 'Salasana vaihdettu onnistuneesti',
    passwordMismatch: 'Salasanat eivät täsmää',
    passwordTooShort: 'Salasanan on oltava vähintään 8 merkkiä',
    changingPassword: 'Vaihdetaan...',
    mustChangePassword: 'Sinun on vaihdettava salasanasi ennen jatkamista.',
    sessionExpiring: 'Istunto päättymässä',
    sessionExpireText: 'Istuntosi päättyy <strong>{{time}}</strong> kuluttua. Tallenna työsi ja kirjaudu uudelleen jatkaaksesi.',
    dismiss: 'Ohita',
    switchNation: 'Vaihda maata',
    returnTo: 'Palaa maahan {{nation}}',
    viewingAs: 'Katselet käyttäjänä',
    loggedInAs: 'kirjautuneena maana {{nation}}',
    trainingMode: 'VAIN HARJOITUSTARKOITUKSIIN',
    dedication: 'Luotu rakkaudella ja omistautumisella ammatille',
  },

  // ============================================================
  // ROLES — User roles and labels
  // ============================================================
  roles: {
    admin: 'Järjestelmänvalvoja',
    excon: 'Harjoituksen valvoja',
    eu: 'EU-koordinaattori',
    planner: 'Suunnittelija',
    hub: 'Solmupisteen johtaja',
    nation: 'Maa',
    readOnly: 'Vain luku',
    systemAdmin: 'Järjestelmänvalvoja',
    transportPlanner: 'Kuljetussuunnittelija',
    systemRoles: 'Järjestelmäroolit',
  },

  // ============================================================
  // STATUS — Request, offer, mission statuses
  // ============================================================
  status: {
    draft: 'Luonnos',
    underReview: 'Tarkistettavana',
    published: 'Julkaistu',
    underSelection: 'Valinnassa',
    accepted: 'Hyväksytty',
    planned: 'Suunniteltu',
    inTransit: 'Kuljetuksessa',
    completed: 'Valmis',
    closed: 'Suljettu',
    withdrawn: 'Peruutettu',
    pending: 'Odottaa',
    rejected: 'Hylätty',
    cancelled: 'Peruutettu',
    active: 'Aktiivinen',
    inactive: 'Ei aktiivinen',
    review: 'Tarkistus',
    selection: 'Valinta',
    transit: 'Kuljetus',
  },

  // ============================================================
  // CATEGORIES — Request categories
  // ============================================================
  categories: {
    medevac: 'MEDEVAC',
    personnel: 'Henkilöstö',
    material: 'Materiaali',
    equipment: 'Kalusto',
    other: 'Muu',
    news: 'Uutiset',
  },

  // ============================================================
  // URGENCY — Urgency levels
  // ============================================================
  urgency: {
    routine: 'Rutiini',
    priority: 'Prioriteetti',
    urgent: 'Kiireellinen',
    immediate: 'Välitön',
  },

  // ============================================================
  // ASSETS — Transport asset types
  // ============================================================
  assetTypes: {
    train: 'Juna',
    ship: 'Laiva',
    aircraft: 'Lentokone',
    bus: 'Bussi',
    ambulance: 'Ambulanssi',
    drone: 'Drooni',
    helicopter: 'Helikopteri',
    ferry: 'Lautta',
    other: 'Muu',
  },

  // ============================================================
  // DASHBOARD
  // ============================================================
  dashboard: {
    title: 'Hallintapaneeli',
    goodMorning: 'Hyvää huomenta',
    goodAfternoon: 'Hyvää iltapäivää',
    goodEvening: 'Hyvää iltaa',
    lastLogin: 'Edellinen kirjautuminen',
    infrastructure: 'Infrastruktuuri',
    transportAssets: 'Kuljetusresurssit',
    treatmentFacilities: 'Hoitolaitokset',
    ucpmExitHubs: 'UCPM Exit Hubs',
    ucpmTransitHubs: 'UCPM Transit Hubs',
    requestStatistics: 'Pyyntötilastot',
    viewAllRequests: 'Näytä kaikki pyynnöt',
    availableAssets: 'Käytettävissä olevat resurssit',
    seated: 'Istuvat',
    lying: 'Makaavat',
    intensive: 'Tehohoito',
    notifications: 'Ilmoitukset',
    markAllRead: 'Merkitse kaikki luetuiksi',
    noNotifications: 'Ei vielä ilmoituksia',
    notifiedWhenActivity: 'Saat ilmoituksen, kun uutta toimintaa tapahtuu',
    viewDetailsBtn: 'Näytä tiedot',
    nationUsers: 'Maan käyttäjät',
    user: 'Käyttäjä',
    roles: 'Roolit',
    noUsersFound: 'Käyttäjiä ei löytynyt',
    participatingNations: 'Osallistuvat maat',
    exerciseDisclaimer: 'Tämä järjestelmä on tarkoitettu vain harjoituskäyttöön. Syötä ainoastaan simuloitua harjoitusdataa. Työnkulut on mukautettu harjoitusskenaarioon ja voivat poiketa todellisista menettelyistä. IT-turvallisuus- ja tietosuojasäännöt ovat täysimääräisesti voimassa.',
    notConfigured: 'Ei määritetty',
    requestCount: '{{count}} pyyntöä',
    clickToView: 'Napsauta nähdäksesi',
    systemAdministration: 'Järjestelmähallinta',
    exerciseControlTitle: 'Harjoituksen hallinta',
    euCoordination: 'EU-koordinointi',
    transportPlanningTitle: 'Kuljetussuunnittelu',
    hubManagement: 'Solmupisteiden hallinta',
  },

  // ============================================================
  // QUICK ACTIONS
  // ============================================================
  quickActions: {
    newRequest: 'Uusi pyyntö',
    myDrafts: 'Omat luonnokset',
    pendingReview: 'Odottaa tarkistusta',
    activeTransports: 'Aktiiviset kuljetukset',
    myPatients: 'Omat potilaat',
  },

  // ============================================================
  // REQUESTS
  // ============================================================
  requests: {
    title: 'Pyynnöt',
    newRequest: 'Uusi pyyntö',
    createRequest: 'Luo pyyntö',
    editRequest: 'Muokkaa pyyntöä',
    requestDetail: 'Pyynnön tiedot',
    requestId: 'Pyynnön ID',
    fromNation: 'Lähettävä maa',
    toNation: 'Vastaanottava maa',
    requestingNation: 'Pyytävä maa',
    receivingNation: 'Vastaanottava maa',
    category: 'Kategoria',
    urgency: 'Kiireellisyys',
    status: 'Tila',
    patients: 'Potilaat',
    patientCount: 'Potilasmäärä',
    offers: 'Tarjoukset',
    offerCount: 'Tarjousmäärä',
    created: 'Luotu',
    updated: 'Päivitetty',
    submittedBy: 'Lähettänyt',
    reviewedBy: 'Tarkastanut',
    description: 'Kuvaus',
    medicalDetails: 'Lääketieteelliset tiedot',
    transportDetails: 'Kuljetustiedot',
    additionalInfo: 'Lisätiedot',
    exitHub: 'UCPM Exit Hub',
    departurePoint: 'Lähtöpiste',
    arrivalPoint: 'Saapumispiste',
    estimatedDeparture: 'Arvioitu lähtö',
    estimatedArrival: 'Arvioitu saapuminen',
    submitForReview: 'Lähetä tarkistettavaksi',
    publish: 'Julkaise',
    startSelection: 'Aloita valinta',
    acceptOffer: 'Hyväksy tarjous',
    markInTransit: 'Merkitse kuljetuksessa',
    markCompleted: 'Merkitse valmiiksi',
    closeRequest: 'Sulje pyyntö',
    withdrawRequest: 'Peru pyyntö',
    withdraw: 'Peru',
    revertToDraft: 'Palauta luonnokseksi',
    deleteRequest: 'Poista pyyntö',
    duplicateRequest: 'Kopioi pyyntö',
    createFollowUp: 'Luo konsolidoitu pyyntö',
    followUpRequest: 'Konsolidoitu pyyntö',
    parentRequest: 'Alkuperäinen pyyntö',
    childRequests: 'Konsolidoidut pyynnöt',
    noRequests: 'Pyyntöjä ei löytynyt',
    noOffers: 'Ei vielä tarjouksia',
    addPatient: 'Lisää potilas',
    removePatient: 'Poista potilas',
    patientDetails: 'Potilaan tiedot',
    contactPerson: 'Yhteyshenkilö',
    contactPhone: 'Yhteyshenkilön puhelin',
    contactEmail: 'Yhteyshenkilön sähköposti',
    specialRequirements: 'Erityisvaatimukset',
    medicalEquipment: 'Lääkintävälineet',
    accompaniment: 'Saattaja',
    timeline: 'Aikajana',
    history: 'Historia',
    addComment: 'Lisää kommentti',
    writeComment: 'Kirjoita kommentti...',
    postComment: 'Lähetä kommentti',
    posting: 'Lähetetään...',
    noComments: 'Ei vielä kommentteja',
    coverageBar: 'Kattavuus',
    covered: 'katettu',
    uncovered: 'kattamaton',
    filterByStatus: 'Suodata tilan mukaan',
    filterByCategory: 'Suodata kategorian mukaan',
    filterByNation: 'Suodata maan mukaan',
    searchRequests: 'Hae pyyntöjä...',
    confirmWithdraw: 'Haluatko varmasti perua tämän pyynnön?',
    confirmDelete: 'Haluatko varmasti poistaa tämän pyynnön?',
    confirmPublish: 'Haluatko varmasti julkaista tämän pyynnön? Se tulee näkyviin kaikille maille.',
    confirmStartSelection: 'Haluatko varmasti aloittaa valinnan? Maat voivat tehdä tarjouksia.',
    warningStartSelection: 'Valinnan aloittaminen tekee tämän pyynnön näkyväksi kaikille osallistuville maille. Ne voivat lähettää tarjouksia tämän pyynnön potilaille. Tätä toimintoa ei voi peruuttaa.',
    warningMakeOffer: 'Lähettämällä tämän tarjouksen sitoudut maasi puolesta tarjoamaan ehdotettua apua. Tämä toiminto ilmoittaa pyytävälle maalle ja harjoituksen valvonnalle.',
    saveDraft: 'Tallenna luonnos',
    saving: 'Tallennetaan...',
    saveAndSubmit: 'Tallenna ja lähetä',
    step: 'Vaihe {{number}}',
    generalInfo: 'Yleistiedot',
    patientInfo: 'Potilastiedot',
    logisticsInfo: 'Logistiikkatiedot',
    reviewSubmit: 'Tarkistus ja lähetys',
    requestTitle: 'Pyynnön otsikko',
    requestDescription: 'Pyynnön kuvaus',
    numberOfPatients: 'Potilasmäärä',
    typeOfAssistance: 'Avun tyyppi',
    medicalTreatment: 'Lääketieteellinen hoito',
    transportAssistance: 'Kuljetusapu',
    both: 'Molemmat',
    treatmentOnly: 'Vain hoito',
    transportOnly: 'Vain kuljetus',
    validationErrors: 'Korjaa seuraavat virheet:',
    fieldRequired: 'Tämä kenttä on pakollinen',
    selectExitHub: 'Valitse lähtösolmupiste',
    createExitHub: 'Luo lähtösolmupiste',
    backToRequests: 'Takaisin pyyntöihin',
    noRequestsFound: 'Pyyntöjä ei löytynyt',
    createFirstRequest: 'Luo ensimmäinen pyyntösi aloittaaksesi',
  },

  // ============================================================
  // OFFERS
  // ============================================================
  offers: {
    title: 'Tarjoukset',
    createOffer: 'Luo tarjous',
    makeOffer: 'Tee tarjous',
    manageOffers: 'Hallitse tarjouksia',
    offerDetail: 'Tarjouksen tiedot',
    offerId: 'Tarjouksen ID',
    offeringNation: 'Tarjoava maa',
    offerType: 'Tarjouksen tyyppi',
    treatment: 'Hoito',
    transport: 'Kuljetus',
    combined: 'Yhdistetty',
    fullOffer: 'Full Offer',
    treatmentOffer: 'Hoitotarjous',
    transportOffer: 'Kuljetustarjous',
    combinedOffer: 'Combined Offer',
    selectPatients: 'Valitse potilaat',
    selectedPatients: 'Valitut potilaat',
    patientSelection: 'Potilasvalinta',
    offerConfiguration: 'Tarjouksen määritys',
    reviewOffer: 'Tarkista tarjous',
    submitOffer: 'Lähetä tarjous',
    submitting: 'Lähetetään...',
    acceptOffer: 'Hyväksy tarjous',
    rejectOffer: 'Hylkää tarjous',
    withdrawOffer: 'Peru tarjous',
    noOffers: 'Tarjouksia ei saatavilla',
    noOffer: 'No Offer',
    offerStatus: 'Tarjouksen tila',
    offerDate: 'Tarjouksen päivämäärä',
    transportAsset: 'Kuljetusresurssi',
    departureDate: 'Lähtöpäivä',
    arrivalDate: 'Saapumispäivä',
    treatmentFacility: 'Hoitolaitos',
    capacity: 'Kapasiteetti',
    availableCapacity: 'Käytettävissä oleva kapasiteetti',
    totalCapacity: 'Kokonaiskapasiteetti',
    selectAsset: 'Valitse resurssi',
    selectFacility: 'Valitse laitos',
    offerNotes: 'Tarjouksen huomautukset',
    confirmAccept: 'Haluatko varmasti hyväksyä tämän tarjouksen?',
    confirmReject: 'Haluatko varmasti hylätä tämän tarjouksen?',
    extendTransport: 'Laajenna kuljetus',
    transportExtension: 'Kuljetuksen laajennus',
    comparisonView: 'Vertailunäkymä',
    shortlist: 'Ehdokaslista',
    addToShortlist: 'Lisää ehdokaslistalle',
    removeFromShortlist: 'Poista ehdokaslistalta',
    leaveConfirmTitle: 'Poistutaanko sivulta?',
    leaveConfirmMessage: 'Sinulla on tallentamattomia muutoksia. Haluatko varmasti poistua?',
    stayOnPage: 'Pysy sivulla',
    leavePage: 'Poistu sivulta',
  },

  // ============================================================
  // MISSIONS / TRANSPORTS
  // ============================================================
  missions: {
    title: 'Kuljetukset',
    missionDetail: 'Kuljetuksen tiedot',
    missionId: 'Kuljetuksen ID',
    missionStatus: 'Kuljetuksen tila',
    createMission: 'Luo kuljetus',
    overview: 'Yleiskatsaus',
    patientsTab: 'Potilaat',
    transportsTab: 'Kuljetusosuudet',
    treatmentTab: 'Hoito',
    reviewTab: 'Tarkistus',
    departure: 'Lähtö',
    arrival: 'Saapuminen',
    origin: 'Lähtöpaikka',
    destination: 'Määränpää',
    stops: 'Pysähdykset',
    addStop: 'Lisää pysähdys',
    removeStop: 'Poista pysähdys',
    stopName: 'Pysähdyksen nimi',
    stopType: 'Pysähdyksen tyyppi',
    estimatedTime: 'Arvioitu aika',
    actualTime: 'Toteutunut aika',
    asset: 'Resurssi',
    driver: 'Kuljettaja',
    crew: 'Miehistö',
    noMissions: 'Kuljetuksia ei löytynyt',
    completeMission: 'Viimeistele kuljetus',
    cancelMission: 'Peruuta kuljetus',
    startTransport: 'Aloita kuljetus',
    missionChain: 'Kuljetusketju',
    linkedMissions: 'Liitetyt kuljetukset',
    handover: 'Luovutus',
    handoverPoint: 'Luovutuspiste',
    pickupPoint: 'Noutopiste',
    dropoffPoint: 'Jättöpiste',
    searchTransports: 'Hae kuljetuksia...',
  },

  // ============================================================
  // PATIENTS
  // ============================================================
  patients: {
    title: 'Potilaat',
    myPatients: 'Omat potilaat',
    patientId: 'Potilaan ID',
    firstName: 'Etunimi',
    lastName: 'Sukunimi',
    dateOfBirth: 'Syntymäaika',
    age: 'Ikä',
    gender: 'Sukupuoli',
    male: 'Mies',
    female: 'Nainen',
    other: 'Muu',
    nationality: 'Kansalaisuus',
    diagnosis: 'Diagnoosi',
    condition: 'Tila',
    stable: 'Vakaa',
    critical: 'Kriittinen',
    serious: 'Vakava',
    treatmentNeeded: 'Tarvittava hoito',
    allergies: 'Allergiat',
    medications: 'Lääkitykset',
    bloodType: 'Veriryhmä',
    weight: 'Paino (kg)',
    infectious: 'Tarttuva tauti',
    mentalHealth: 'Mielenterveys',
    mobility: 'Liikkuvuus',
    ambulatory: 'Kävelevä',
    wheelchair: 'Pyörätuoli',
    stretcher: 'Paarit',
    intensive: 'Tehohoito',
    oxygenRequired: 'Happi tarvitaan',
    ventilator: 'Hengityskone',
    medicalEscort: 'Lääkintäsaattaja',
    noPatients: 'Potilaita ei löytynyt',
    patientDetails: 'Potilaan tiedot',
    medicalHistory: 'Sairaushistoria',
    travelDocuments: 'Matkustusasiakirjat',
    passport: 'Passi',
    pseudonymizedId: 'Pseudonymisoitu ID',
    sensitiveData: 'Arkaluonteinen tieto',
    journey: 'Potilaan matka',
    assignedTo: 'Osoitettu',
    currentLocation: 'Nykyinen sijainti',
    importPatients: 'Tuo potilaita',
    exportPatients: 'Vie potilaita',
    seated: 'Istuvat',
    lying: 'Makaavat',
  },

  // ============================================================
  // USERS
  // ============================================================
  users: {
    title: 'Käyttäjät',
    createUser: 'Luo käyttäjä',
    editUser: 'Muokkaa käyttäjää',
    deleteUser: 'Poista käyttäjä',
    username: 'Käyttäjänimi',
    displayName: 'Näyttönimi',
    email: 'Sähköposti',
    password: 'Salasana',
    role: 'Rooli',
    roles: 'Roolit',
    nation: 'Maa',
    active: 'Aktiivinen',
    lastLogin: 'Edellinen kirjautuminen',
    createdAt: 'Luotu',
    isNation: 'Maa',
    isEU: 'EU',
    isAdmin: 'Ylläpitäjä',
    isExcon: 'EXCON',
    isPlanner: 'Suunnittelija',
    isHub: 'Solmupiste',
    isReadOnly: 'Vain luku',
    noUsers: 'Käyttäjiä ei löytynyt',
    confirmDelete: 'Haluatko varmasti poistaa tämän käyttäjän?',
    resetPassword: 'Nollaa salasana',
    generatePassword: 'Luo salasana',
    searchUsers: 'Hae käyttäjiä...',
    userCreated: 'Käyttäjä luotu onnistuneesti',
    userUpdated: 'Käyttäjä päivitetty onnistuneesti',
    userDeleted: 'Käyttäjä poistettu onnistuneesti',
    selectNation: 'Valitse maa',
    mustChangePassword: 'Salasana on vaihdettava seuraavalla kirjautumiskerralla',
    flagImage: 'Lippukuva',
    exportUsers: 'Vie käyttäjät',
    importUsers: 'Tuo käyttäjät',
  },

  // ============================================================
  // ASSETS
  // ============================================================
  assets: {
    title: 'Resurssit',
    createAsset: 'Luo resurssi',
    editAsset: 'Muokkaa resurssia',
    deleteAsset: 'Poista resurssi',
    assetName: 'Resurssin nimi',
    assetType: 'Resurssin tyyppi',
    capacitySeated: 'Kapasiteetti (istuvat)',
    capacityLying: 'Kapasiteetti (makaavat)',
    capacityIntensive: 'Kapasiteetti (tehohoito)',
    owner: 'Omistaja',
    operator: 'Operoija',
    baseLocation: 'Tukikohta',
    range: 'Kantama',
    speed: 'Nopeus',
    noAssets: 'Resursseja ei löytynyt',
    confirmDelete: 'Haluatko varmasti poistaa tämän resurssin?',
    searchAssets: 'Hae resursseja...',
    assetCreated: 'Resurssi luotu onnistuneesti',
    assetUpdated: 'Resurssi päivitetty onnistuneesti',
    assetDeleted: 'Resurssi poistettu onnistuneesti',
    exportAssets: 'Vie resurssit',
  },

  // ============================================================
  // HUBS / START POINTS
  // ============================================================
  hubs: {
    title: 'Solmupisteet',
    startPoints: 'Lähtöpisteet',
    createHub: 'Luo solmupiste',
    editHub: 'Muokkaa solmupistettä',
    deleteHub: 'Poista solmupiste',
    hubName: 'Solmupisteen nimi',
    hubType: 'Solmupisteen tyyppi',
    exitHub: 'UCPM Exit Hub',
    transitHub: 'UCPM Transit Hub',
    entryHub: 'Saapumissolmupiste',
    airport: 'Lentokenttä',
    seaport: 'Satama',
    railStation: 'Rautatieasema',
    roadPoint: 'Maantiepiste',
    ucpmClassification: 'UCPM-luokitus',
    icaoCode: 'ICAO-koodi',
    iataCode: 'IATA-koodi',
    noHubs: 'Solmupisteitä ei löytynyt',
    confirmDelete: 'Haluatko varmasti poistaa tämän solmupisteen?',
    searchHubs: 'Hae solmupisteitä...',
    nationAssignment: 'Maan osoitus',
    assignNations: 'Osoita maat',
  },

  // ============================================================
  // HOSPITALS / TREATMENT FACILITIES
  // ============================================================
  hospitals: {
    title: 'Hoitolaitokset',
    createFacility: 'Luo laitos',
    editFacility: 'Muokkaa laitosta',
    deleteFacility: 'Poista laitos',
    facilityName: 'Laitoksen nimi',
    facilityType: 'Laitoksen tyyppi',
    hospitalName: 'Sairaalan nimi',
    bedCapacity: 'Vuodekapasiteetti',
    specialties: 'Erikoisalat',
    availableBeds: 'Vapaana olevat vuoteet',
    totalBeds: 'Vuoteet yhteensä',
    contactPerson: 'Yhteyshenkilö',
    noFacilities: 'Hoitolaitoksia ei löytynyt',
    confirmDelete: 'Haluatko varmasti poistaa tämän laitoksen?',
    searchFacilities: 'Hae laitoksia...',
    hubNationAssignment: 'Solmupisteen maan osoitus',
  },

  // ============================================================
  // SCHEDULES
  // ============================================================
  schedules: {
    title: 'Aikataulut',
    createSchedule: 'Luo aikataulu',
    editSchedule: 'Muokkaa aikataulua',
    deleteSchedule: 'Poista aikataulu',
    scheduleName: 'Aikataulun nimi',
    scheduleType: 'Aikataulun tyyppi',
    recurring: 'Toistuva',
    oneTime: 'Kertaluonteinen',
    frequency: 'Toistuvuus',
    daily: 'Päivittäin',
    weekly: 'Viikoittain',
    startDate: 'Alkamispäivä',
    endDate: 'Päättymispäivä',
    departureTime: 'Lähtöaika',
    arrivalTime: 'Saapumisaika',
    stops: 'Pysähdykset',
    addStop: 'Lisää pysähdys',
    noSchedules: 'Aikatauluja ei löytynyt',
    bookings: 'Varaukset',
    timeline: 'Aikajana',
  },

  // ============================================================
  // NOTIFICATIONS
  // ============================================================
  notifications: {
    title: 'Ilmoitukset',
    markAllRead: 'Merkitse kaikki luetuiksi',
    markAsRead: 'Merkitse luetuksi',
    markAsUnread: 'Merkitse lukemattomaksi',
    noNotifications: 'Ei ilmoituksia',
    viewAll: 'Näytä kaikki ilmoitukset',
    settings: 'Ilmoitusasetukset',
    emailNotifications: 'Sähköposti-ilmoitukset',
    inAppNotifications: 'Sovelluksen sisäiset ilmoitukset',
    notifyOn: 'Ilmoita minulle',
    requestCreated: 'Uusi pyyntö',
    requestPublished: 'Pyyntö julkaistu',
    requestClosed: 'Pyyntö suljettu',
    requestCompleted: 'Pyyntö valmis',
    commentAdded: 'Uusi kommentti',
    offerReceived: 'Tarjous vastaanotettu',
    offerAccepted: 'Tarjous hyväksytty',
    statusChanged: 'Tila muuttunut',
    selectionStarted: 'Valinta aloitettu',
    missionCreated: 'Kuljetus luotu',
    missionStatusUpdated: 'Kuljetus päivitetty',
    transportPartnerNamed: 'Kuljetuskumppani',
    transportExtensionReceived: 'Kuljetuksen laajennus',
  },

  // ============================================================
  // SETTINGS
  // ============================================================
  settings: {
    title: 'Asetukset',
    general: 'Yleiset',
    system: 'Järjestelmä',
    email: 'Sähköposti',
    sync: 'Synkronointi',
    security: 'Turvallisuus',
    appearance: 'Ulkoasu',
    systemName: 'Järjestelmän nimi',
    systemEmail: 'Järjestelmän sähköposti',
    maintenanceMode: 'Huoltotila',
    readOnlyMode: 'Vain luku -tila',
    emailEnabled: 'Sähköposti käytössä',
    smtpHost: 'SMTP-palvelin',
    smtpPort: 'SMTP-portti',
    smtpUser: 'SMTP-käyttäjä',
    smtpPassword: 'SMTP-salasana',
    senderEmail: 'Lähettäjän sähköposti',
    senderName: 'Lähettäjän nimi',
    testEmail: 'Lähetä testisähköposti',
    syncEnabled: 'Synkronointi käytössä',
    syncUrl: 'Synkronointi-URL',
    syncApiKey: 'Synkronoinnin API-avain',
    settingsSaved: 'Asetukset tallennettu onnistuneesti',
    helpdesk: 'Tukipalvelu',
    helpdeskTitle: 'Tukipalvelun otsikko',
    helpdeskEmail: 'Tukipalvelun sähköposti',
    helpdeskPhone: 'Tukipalvelun puhelin',
    helpdeskInfo: 'Tukipalvelun tiedot',
    realLifeSupport: 'Tosielämän tuki',
    trainingMode: 'Harjoitustila',
  },

  // ============================================================
  // AUDIT LOGS
  // ============================================================
  auditLogs: {
    title: 'Tarkastusloki',
    action: 'Toiminto',
    user: 'Käyttäjä',
    target: 'Kohde',
    details: 'Tiedot',
    timestamp: 'Aikaleima',
    ipAddress: 'IP-osoite',
    noLogs: 'Tarkastuslokimerkintöjä ei löytynyt',
    searchLogs: 'Hae lokimerkintöjä...',
    filterByAction: 'Suodata toiminnon mukaan',
    filterByUser: 'Suodata käyttäjän mukaan',
    exportLogs: 'Vie lokit',
    exportCsv: 'Vie CSV',
  },

  // ============================================================
  // EXERCISE CONTROL
  // ============================================================
  exerciseControl: {
    title: 'Harjoituksen hallinta',
    currentDay: 'Nykyinen päivä',
    exerciseDay: 'Harjoituspäivä',
    nextDay: 'Seuraava päivä',
    previousDay: 'Edellinen päivä',
    resetExercise: 'Nollaa harjoitus',
    startExercise: 'Aloita harjoitus',
    endExercise: 'Lopeta harjoitus',
    dayReset: 'Päivän nollaus',
    confirmReset: 'Haluatko varmasti nollata harjoituspäivän? Kaikki nykyisen päivän tiedot poistetaan.',
    resetInProgress: 'Nollaus käynnissä...',
    maintenanceMode: 'Huoltotila',
    enableMaintenance: 'Ota huoltotila käyttöön',
    disableMaintenance: 'Poista huoltotila käytöstä',
  },

  // ============================================================
  // DATA SYNC
  // ============================================================
  dataSync: {
    title: 'Tietojen synkronointi',
    syncStatus: 'Synkronoinnin tila',
    lastSync: 'Edellinen synkronointi',
    pendingItems: 'Odottavat kohteet',
    syncNow: 'Synkronoi nyt',
    syncing: 'Synkronoidaan...',
    syncSuccess: 'Synkronointi onnistui',
    syncFailed: 'Synkronointi epäonnistui',
    outbox: 'Lähtevät',
    inbox: 'Saapuvat',
    configuration: 'Määritykset',
    targetUrl: 'Kohde-URL',
    apiKey: 'API-avain',
  },

  // ============================================================
  // MAP
  // ============================================================
  map: {
    title: 'Kartta',
    layers: 'Tasot',
    requests: 'Pyynnöt',
    hubs: 'Solmupisteet',
    facilities: 'Laitokset',
    routes: 'Reitit',
    showAll: 'Näytä kaikki',
    hideAll: 'Piilota kaikki',
    zoomIn: 'Lähennä',
    zoomOut: 'Loitonna',
    resetView: 'Palauta näkymä',
    satellite: 'Satelliitti',
    terrain: 'Maasto',
    offline: 'Ei verkkoyhteyttä',
    online: 'Verkossa',
    tilesOffline: 'Karttaruudut palvellaan paikallisesti',
    tilesOnline: 'Karttaruudut ladataan verkkopalvelimilta',
  },

  // ============================================================
  // STATISTICS
  // ============================================================
  statistics: {
    title: 'Tilastot',
    overview: 'Yleiskatsaus',
    requestsByStatus: 'Pyynnöt tilan mukaan',
    requestsByCategory: 'Pyynnöt kategorian mukaan',
    requestsByNation: 'Pyynnöt maan mukaan',
    offersByStatus: 'Tarjoukset tilan mukaan',
    patientsByCondition: 'Potilaat tilan mukaan',
    transportsByStatus: 'Kuljetukset tilan mukaan',
    timeline: 'Aikajana',
    totalRequests: 'Pyynnöt yhteensä',
    totalOffers: 'Tarjoukset yhteensä',
    totalPatients: 'Potilaat yhteensä',
    totalTransports: 'Kuljetukset yhteensä',
    averageResponseTime: 'Keskimääräinen vasteaika',
    completionRate: 'Valmistumisaste',
  },

  // ============================================================
  // EXERCISE STATS
  // ============================================================
  exerciseStats: {
    title: 'Harjoitustilastot',
    overview: 'Yleiskatsaus',
    byCategory: 'Kategorian mukaan',
    byNation: 'Maan mukaan',
    byDay: 'Päivän mukaan',
    totalPatientsMoved: 'Siirretyt potilaat yhteensä',
    totalRequestsProcessed: 'Käsitellyt pyynnöt yhteensä',
    averageProcessingTime: 'Keskimääräinen käsittelyaika',
  },

  // ============================================================
  // FLOW DIAGRAM
  // ============================================================
  flowDiagram: {
    title: 'Virtauskaavio',
    sankey: 'Sankey',
    nodeGraph: 'Solmukaavio',
    refresh: 'Päivitä',
    noData: 'Virtaustietoja ei saatavilla',
  },

  // ============================================================
  // ABOUT
  // ============================================================
  about: {
    title: 'Tietoja',
    version: 'Versio',
    systemInfo: 'Järjestelmätiedot',
    buildDate: 'Koontipäivämäärä',
    environment: 'Ympäristö',
    description: 'ARCOS — Edistynyt pyyntöjen viestintäjärjestelmä',
    subtitle: 'Uhrien avustaminen ja lääkintäoperaatiot',
    whatIsArcos: 'Mikä on ARCOS? – Selitys harjoituksen osallistujille',
    arcosDesc1: 'ARCOS is a digital tool used in this exercise to support and structure international communication, requests and coordination processes between the participating actors. It is important to understand that ARCOS is not an operational system and does not replace real-world platforms such as CECIS (Common Emergency Communication and Information System) or EWRS (Early Warning and Response System).',
    arcosDesc2: 'Instead, ARCOS provides a simplified, exercise-oriented representation of the basic principles behind these systems. Its purpose is to allow participants to work within a common, consistent framework during the exercise, without requiring access to protected or operational environments.',
    arcosUsedFor: 'During the exercise, ARCOS is used to represent typical processes such as:',
    arcosUsedForItem1: 'submitting and managing requests for assistance (e.g. medical support, personnel or material),',
    arcosUsedForItem2: 'coordinating and responding to offers of support from other nations or organizations,',
    arcosUsedForItem3: 'tracking the status and progression of requests,',
    arcosUsedForItem4: 'and representing simplified transport or evacuation workflows.',
    arcosDesc3: 'The workflows in ARCOS are intentionally simplified and adapted to the specific training objectives of the exercise. In addition, ARCOS includes certain functions that do not exist in real systems but are useful for training and discussion purposes. This allows the exercise to focus on decision-making, coordination and cooperation rather than on technical system details.',
    arcosDesc4: 'The goal of ARCOS is not to simulate a perfect or complete real-world system. Instead, it aims to provide a clear, structured and shared understanding of how multinational coordination processes work in principle. ARCOS is meant to support the exercise, make communication transparent, and help participants concentrate on the exercise objectives.',
    arcosDesc5: 'If certain elements or workflows in ARCOS differ from real-life procedures you may be familiar with, this is expected. ARCOS reflects the logic of the exercise, not the full operational complexity of systems such as CECIS or EWRS.',
    facilitatedBy: 'MMCC-E:n tuella',
    dhcInitiative: 'The Digital Health Corner (DHC) is a joint initiative by:',
    dhcAuthor1: 'Sven Giegerich — German Armed Forces',
    dhcAuthor2: 'Mohamad Haji — Belgian Defence',
    dhcConviction: 'Born from the conviction that innovation thrives where passion meets pragmatism.',
    dhcInspired: 'Inspired by the initial spark ignited by MMCC-E, we set out to create simple yet effective solutions based on existing systems – tools that make Tabletop Exercises (TTX) more efficient, realistic, and accessible.',
    dhcLove: 'We do this because we love our work and we believe that digital ideas can reshape collaboration in military healthcare.',
    dhcOpen: 'The DHC is an open platform: free from hierarchies, open to ideas, driven by curiosity and a spirit of collaboration. We are looking for fellow innovators who share our enthusiasm – people who want to think, build, and create together.',
    dhcClosing: 'Digital Health Corner – missä uteliaisuus kohtaa yhteistyön.',
  },

  // ============================================================
  // DOCUMENTATION
  // ============================================================
  documentation: {
    title: 'Dokumentaatio',
    gettingStarted: 'Aloittaminen',
    userGuide: 'Käyttöohje',
    faq: 'UKK',
    troubleshooting: 'Vianmääritys',
    apiReference: 'API-viite',
    downloadTemplate: 'Lataa malli',
    overviewDesc: 'CAMO26 is a simulation system for the CECIS workflow. As a <strong>Nation user</strong>, you can create and manage assistance requests, communicate with other nations, and coordinate medical support operations.',
    dashboardDesc: 'The Dashboard provides an overview of all requests in the system and shows statistics by status. Click on any statistic card to view filtered requests.',
    navigationInfo: 'Navigation Information',
    navDashboard: 'Dashboard - System overview and statistics',
    navRequests: 'Requests - View all requests in list format',
    navNewRequest: 'New Request - Create a new assistance request',
    navNotifications: 'Notifications - Bell icon in header shows new activities',
    step1Title: 'Step 1: Basic Information',
    step1Item1: 'Click <strong>"New Request"</strong> in the navigation menu',
    step1Item2: 'Enter a descriptive <strong>Title</strong> for your request',
    step1Item3: 'Provide detailed <strong>Description</strong> of what assistance is needed',
    step1Item4: 'Select the <strong>Category</strong>:',
    catMedevac: 'MEDEVAC - Medical evacuation of patients',
    catPersonnel: 'PERSONNEL - Request for medical personnel',
    catEquipment: 'EQUIPMENT - Request for medical equipment or supplies',
    catOther: 'OTHER - Other types of assistance',
    step1Item5: 'Set <strong>Urgency</strong> level (LOW, NORMAL, HIGH)',
    step1Item6: 'Optionally set an <strong>"Answer By"</strong> deadline',
    step2Title: 'Step 2: Add Patient Data (MEDEVAC only)',
    step2Desc: 'For MEDEVAC requests, you can add patient information:',
    step2ManualEntry: 'Manual Entry - Fill out the patient form for each individual',
    step2ExcelUpload: 'Excel Upload - Upload a pre-filled Excel file with patient data',
    step2ExcelItem1: 'Download the template from the request page',
    step2ExcelItem2: 'Fill in patient details following the format',
    step2ExcelItem3: 'Upload the completed file',
    step3Title: 'Step 3: Submit for Review',
    step3Desc: 'Once your request is complete, submit it for EU review. The request moves to <strong>"UNDER_REVIEW"</strong> status and EU coordinators are notified.',
    requestWorkflow: 'Request Workflow',
    workflowDraft: 'Initial creation - only visible to you',
    workflowReview: 'Submitted to EU for approval',
    workflowPublished: 'Visible to all nations - can receive offers',
    workflowTransit: 'Offer accepted - assistance in progress',
    workflowCompleted: 'Assistance successfully delivered',
    workflowNote: '<strong>Note:</strong> EU coordinators can also set requests to <strong>CLOSED</strong> status if needed.',
    viewingRequests: 'Viewing and Managing Requests',
    ownRequests: 'Your Own Requests',
    ownRequestItem1: 'View all your requests regardless of status',
    ownRequestItem2: 'Edit DRAFT requests before submission',
    ownRequestItem3: 'Track status changes and updates',
    ownRequestItem4: 'Accept offers from other nations',
    ownRequestItem5: 'Mark requests as COMPLETED when assistance is delivered',
    otherRequests: 'Other Nations\' Requests',
    otherRequestItem1: 'View all PUBLISHED requests from other nations',
    otherRequestItem2: 'Add comments to discuss details',
    otherRequestItem3: 'Submit offers to provide assistance',
    otherRequestItem4: 'Track which requests have been fulfilled',
    fullOffer: 'Full Offer',
    fullOfferDesc: 'You can fulfill the entire request:',
    fullOfferItem1: 'Open a PUBLISHED request from another nation',
    fullOfferItem2: 'Click <strong>"Make Offer"</strong>',
    fullOfferItem3: 'Describe what you can provide',
    fullOfferItem4: 'Submit the offer',
    partialOffer: 'Partial Offer (MEDEVAC only)',
    partialOfferDesc: 'For MEDEVAC requests, you can offer to take some patients:',
    partialOfferItem1: 'Select specific patients from the list',
    partialOfferItem2: 'Describe your capacity and capabilities',
    partialOfferItem3: 'Submit the partial offer',
    offerImportant: '<strong>Important:</strong> The requesting nation must accept your offer before it becomes active.',
    commentsUsage: 'Use comments on PUBLISHED requests to:',
    commentItem1: 'Ask questions about requirements',
    commentItem2: 'Clarify details before making an offer',
    commentItem3: 'Coordinate logistics and timing',
    commentItem4: 'Share updates during execution',
    notifDesc: 'You receive notifications for:',
    notifItem1: 'New published requests from other nations',
    notifItem2: 'Comments on your requests or requests you\'ve interacted with',
    notifItem3: 'Offers received on your requests',
    notifItem4: 'Status changes on your requests',
    notifItem5: 'Offer acceptance/rejection',
    notifBell: 'Check the bell icon in the header to view notifications. The badge shows unread count.',
    requestIdFormat: 'Request ID Format',
    requestIdDesc: 'Each request receives a unique ID in the format: <code>XXX-YYYY-AAA</code>',
    requestIdPart1: '<strong>XXX</strong> - Your nation\'s ISO 3166-1 alpha-3 code (e.g., DEU, FRA, GBR)',
    requestIdPart2: '<strong>YYYY</strong> - Current year',
    requestIdPart3: '<strong>AAA</strong> - Sequential number for your nation this year',
    requestIdExample: '<strong>Example:</strong> <code>DEU-2025-001</code> is Germany\'s first request in 2025',
    bestPractices: 'Best Practices',
    effectiveRequests: 'Creating Effective Requests',
    effectiveItem1: 'Use clear, descriptive titles',
    effectiveItem2: 'Provide complete details in the description',
    effectiveItem3: 'Set realistic urgency levels',
    effectiveItem4: 'For MEDEVAC: Include accurate patient information',
    effectiveItem5: 'Set appropriate deadlines for responses',
    collaboration: 'Collaboration',
    collabItem1: 'Respond promptly to comments on your requests',
    collabItem2: 'Review offers carefully before accepting',
    collabItem3: 'Update request status as situations evolve',
    collabItem4: 'Mark requests as COMPLETED when assistance is delivered',
    collabItem5: 'Communicate any changes or issues through comments',
    systemEtiquette: 'System Etiquette',
    etiquetteItem1: 'Only submit requests for review when they are complete',
    etiquetteItem2: 'Do not create duplicate requests',
    etiquetteItem3: 'Use appropriate urgency levels - reserve HIGH for true emergencies',
    etiquetteItem4: 'Close or complete requests that are no longer needed',
    supportDesc: 'For technical issues or questions about using the system, please contact:',
    supportContact: 'Multinational Medical Coordination Centre - Europe (MMCC-E)',
    importantNotice: 'Important Notice',
    importantNoticeText1: 'This is a simulation system for training and exercise purposes only.',
    importantNoticeText2: 'CAMO26 simulates the basic workflow of CECIS (Common Emergency Communication and Information System). Many CECIS functions are not represented here. This system is designed for tabletop exercises (TTX) and should not be used for actual emergency operations.',
  },

  // ============================================================
  // PATIENT IMPORT
  // ============================================================
  patientImport: {
    title: 'Potilastuonti',
    uploadFile: 'Lataa tiedosto',
    selectFile: 'Valitse tiedosto',
    preview: 'Esikatselu',
    importNow: 'Tuo nyt',
    importing: 'Tuodaan...',
    importSuccess: '{{count}} potilasta tuotu onnistuneesti',
    importFailed: 'Tuonti epäonnistui',
    downloadTemplate: 'Lataa malli',
    dragDrop: 'Vedä ja pudota tiedosto tähän tai napsauta valitaksesi',
    supportedFormats: 'Tuetut muodot: XLSX, XLS, CSV',
    rowsFound: '{{count}} riviä löydetty',
    validRows: '{{count}} kelvollista riviä',
    invalidRows: '{{count}} virheellistä riviä',
    duplicateRows: '{{count}} kaksoiskappaleetta',
    previewData: 'Esikatsele tietoja',
  },

  // ============================================================
  // TRANSPORT PLANNING / BOOKING
  // ============================================================
  transportPlanning: {
    title: 'Kuljetussuunnittelu',
    planRoute: 'Suunnittele reitti',
    routeBuilder: 'Reittisuunnittelija',
    addWaypoint: 'Lisää välipiste',
    removeWaypoint: 'Poista välipiste',
    estimatedDuration: 'Arvioitu kesto',
    distance: 'Etäisyys',
    selectVehicle: 'Valitse ajoneuvo',
  },

  transportBooking: {
    title: 'Kuljetusvaraus',
    bookTransport: 'Varaa kuljetus',
    availableSlots: 'Vapaat ajat',
    bookingConfirmed: 'Varaus vahvistettu',
    cancelBooking: 'Peruuta varaus',
  },

  // ============================================================
  // CAPACITY PLANNING
  // ============================================================
  capacityPlanning: {
    title: 'Kapasiteettisuunnittelu',
    totalCapacity: 'Kokonaiskapasiteetti',
    usedCapacity: 'Käytetty kapasiteetti',
    availableCapacity: 'Käytettävissä oleva kapasiteetti',
    utilizationRate: 'Käyttöaste',
  },

  // ============================================================
  // TEMPLATES
  // ============================================================
  templates: {
    assetTemplates: 'Resurssimallit',
    dayTemplates: 'Päivämallit',
    createTemplate: 'Luo malli',
    editTemplate: 'Muokkaa mallia',
    deleteTemplate: 'Poista malli',
    templateName: 'Mallin nimi',
    applyTemplate: 'Käytä mallia',
    noTemplates: 'Malleja ei löytynyt',
    confirmDelete: 'Haluatko varmasti poistaa tämän mallin?',
    confirmApply: 'Haluatko varmasti käyttää tätä mallia? Tämä korvaa olemassa olevat tiedot.',
    exportTemplates: 'Vie mallit',
  },

  // ============================================================
  // ANNOUNCEMENT TICKER
  // ============================================================
  announcements: {
    title: 'Tiedotenauha',
    createAnnouncement: 'Luo tiedote',
    editAnnouncement: 'Muokkaa tiedotetta',
    deleteAnnouncement: 'Poista tiedote',
    message: 'Viesti',
    startTime: 'Alkamisaika',
    endTime: 'Päättymisaika',
    active: 'Aktiivinen',
    noAnnouncements: 'Ei tiedotteita',
    confirmDelete: 'Haluatko varmasti poistaa tämän tiedotteen?',
  },

  // ============================================================
  // COMPONENTS — Reusable component strings
  // ============================================================
  components: {
    // DataTable
    dataTable: {
      search: 'Hae...',
      noResults: 'Tuloksia ei löytynyt',
      showing: 'Näytetään {{from}}–{{to}} / {{total}}',
      rowsPerPage: 'Riviä sivulla',
      previousPage: 'Edellinen sivu',
      nextPage: 'Seuraava sivu',
    },
    // ConfirmDialog
    confirmDialog: {
      confirm: 'Vahvista',
      cancel: 'Peruuta',
    },
    // LeaveConfirmDialog
    leaveConfirm: {
      title: 'Tallentamattomia muutoksia',
      message: 'Sinulla on tallentamattomia muutoksia. Haluatko varmasti poistua tältä sivulta?',
      stay: 'Pysy sivulla',
      leave: 'Poistu sivulta',
    },
    // EmptyState
    emptyState: {
      noData: 'Tietoja ei saatavilla',
    },
    // ErrorBoundary
    errorBoundary: {
      title: 'Jokin meni pieleen',
      message: 'Odottamaton virhe tapahtui. Yritä päivittää sivu.',
      retry: 'Yritä uudelleen',
    },
    // ExportButton
    exportButton: {
      export: 'Vie',
      exporting: 'Viedään...',
      csv: 'CSV',
      excel: 'Excel',
      pdf: 'PDF',
      print: 'Tulosta',
    },
    // StatusProgressBar
    progressBar: {
      draft: 'Luonnos',
      review: 'Tarkistus',
      published: 'Julkaistu',
      selection: 'Valinta',
      inTransit: 'Kuljetuksessa',
      completed: 'Valmis',
    },
    // ReadOnlyBanner
    readOnlyBanner: {
      title: 'Verkkoinstanssi',
      message: 'Vain luku -tila. Tiedot synkronoidaan ensisijaiselta palvelimelta.',
    },
    // ImpersonationBanner
    impersonationBanner: {
      viewingAs: 'Katselet käyttäjänä',
      loggedInAs: 'kirjautuneena maana {{nation}}',
      returnTo: 'Palaa maahan {{nation}}',
    },
    // GlobalSearch
    globalSearch: {
      placeholder: 'Hae sivuja, pyyntöjä, kuljetuksia...',
      searching: 'Haetaan...',
      noResults: 'Ei tuloksia haulle "{{query}}"',
      navigate: 'Siirry',
      select: 'Valitse',
      close: 'Sulje',
      pages: {
        dashboard: 'Hallintapaneeli',
        requests: 'Pyynnöt',
        transports: 'Kuljetukset',
        map: 'Kartta',
        myPatients: 'Omat potilaat',
        flowDiagram: 'Virtauskaavio',
        statistics: 'Tilastot',
        assets: 'Resurssit',
        startPoints: 'Lähtöpisteet / Solmupisteet',
        treatmentFacilities: 'Hoitolaitokset',
        users: 'Käyttäjät',
        settings: 'Asetukset',
        auditLogs: 'Tarkastusloki',
        exerciseControl: 'Harjoituksen hallinta',
        dataSync: 'Tietojen synkronointi',
        patientImport: 'Potilastuonti',
        notifications: 'Ilmoitukset',
        documentation: 'Dokumentaatio',
      },
      actions: {
        importPatientsJson: 'Tuo Potilaita (JSON)',
        importPatientsExcel: 'Tuo Potilaita (Excel)',
        importUsers: 'Tuo Käyttäjiä (Excel)',
        importAssetTemplates: 'Tuo Omaisuuspohjia (Excel)',
        importDayTemplates: 'Tuo Päiväpohjan merkintöjä (Excel)',
        exportRequests: 'Vie Pyyntöjä (Excel)',
        exportPatients: 'Vie Potilaita (Excel)',
        exportUsers: 'Vie Käyttäjiä (Excel)',
        exportCredentials: 'Vie Tunnukset (PDF)',
        exportAuditExcel: 'Vie Tarkastusloki (Excel)',
        exportAuditPdf: 'Vie Tarkastusloki (PDF)',
        pagePatientImport: 'Potilastuonnin sivu',
        pageRequestDetail: 'Pyynnön tiedot sivu',
        pageUsers: 'Käyttäjähallinta sivu',
        pageAssetTemplates: 'Omaisuuspohjien sivu',
        pageDayTemplates: 'Päiväpohjien sivu',
        pageRequests: 'Pyyntöluettelo sivu',
        pageAuditLogs: 'Tarkastuslokin sivu',
      },
    },
    // SessionTimeout
    sessionTimeout: {
      title: 'Istunto päättymässä',
      message: 'Istuntosi päättyy <strong>{{time}}</strong> kuluttua. Tallenna työsi ja kirjaudu uudelleen jatkaaksesi.',
      dismiss: 'Ohita',
      logoutNow: 'Kirjaudu ulos nyt',
    },
    // TimezoneClock
    timezoneClock: {
      selectTimezones: 'Valitse 4 aikavyöhykettä',
      configure: 'Määritä aikavyöhykkeet',
      reset: 'Palauta',
      apply: 'Käytä',
    },
    // CoordinatePicker
    coordinatePicker: {
      pickLocation: 'Valitse sijainti',
      latitude: 'Leveysaste',
      longitude: 'Pituusaste',
      clickToSelect: 'Napsauta kartalla valitaksesi sijainnin',
    },
    // Modal
    modal: {
      close: 'Sulje',
    },
    // Breadcrumb
    breadcrumb: {
      home: 'Etusivu',
    },
  },

  // ============================================================
  // MAINTENANCE SCREEN
  // ============================================================
  maintenance: {
    title: 'Järjestelmähuolto',
    message: 'Järjestelmää nollataan seuraavaa harjoituspäivää varten. Odota prosessin valmistumista.',
    autoRefresh: 'Tämä sivu päivittyy automaattisesti, kun järjestelmä on jälleen käytettävissä.',
  },

  // ============================================================
  // EXERCISE ANALYTICS
  // ============================================================
  exerciseAnalytics: {
    missionStatus: {
      draft: 'Draft',
      planned: 'Planned',
      active: 'Active',
      inTransit: 'In Transit',
      completed: 'Completed',
      cancelled: 'Cancelled',
    },
    actions: {
      USER_LOGIN: 'User Login',
      USER_LOGOUT: 'User Logout',
      USER_CREATED: 'User Created',
      USER_UPDATED: 'User Updated',
      USER_DELETED: 'User Deleted',
      REQUEST_CREATED: 'Request Created',
      REQUEST_UPDATED: 'Request Updated',
      REQUEST_SUBMITTED: 'Request Submitted',
      REQUEST_PUBLISHED: 'Request Published',
      REQUEST_CLOSED: 'Request Closed',
      REQUEST_COMPLETED: 'Request Completed',
      OFFER_CREATED: 'Offer Created',
      OFFER_UPDATED: 'Offer Updated',
      OFFER_ACCEPTED: 'Offer Accepted',
      OFFER_DELETED: 'Offer Deleted',
      MISSION_CREATED: 'Mission Created',
      MISSION_UPDATED: 'Mission Updated',
      MISSION_STATUS_UPDATED: 'Mission Status',
      MISSION_SPLIT: 'Mission Split',
      MISSION_DELETED: 'Mission Deleted',
      COMMENT_CREATED: 'Comment Created',
      TRANSPORT_CREATED: 'Transport Created',
      TRANSPORT_COMPLETED: 'Transport Completed',
      SELECTION_STARTED: 'Selection Started',
      SELECTION_ENDED: 'Selection Ended',
      FILE_UPLOADED: 'File Uploaded',
      PATIENT_IDS_UPDATED: 'Patient IDs Updated',
      SCHEDULE_CREATED: 'Schedule Created',
      BOOKING_CREATED: 'Booking Created',
      EXERCISE_DAY_ACTIVATED: 'Day Activated',
      EXERCISE_DAY_RESET: 'Day Reset',
      SETTING_UPDATED: 'Setting Updated',
      PATIENTS_IMPORTED: 'Patients Imported',
      PATIENTS_EXCLUDED: 'Patients Excluded',
      PATIENTS_ADDED: 'Patients Added',
      REQUEST_DELETED: 'Request Deleted',
      REQUEST_REVERTED_TO_DRAFT: 'Reverted to Draft',
    },
    transportMode: {
      SEATED: 'Seated',
      LYING: 'Lying',
      TBA: 'TBA',
    },
    dependency: {
      LOW: 'Low',
      MEDIUM: 'Medium',
      HIGH: 'High',
      TBA: 'TBA',
    },
  },

  // ============================================================
  // HEALTH DASHBOARD
  // ============================================================
  healthDashboard: {
    title: 'System Health Dashboard',
    unableToLoad: 'Unable to Load Health Data',
    retry: 'Retry',
    refresh: 'Refresh',
    refreshFailed: 'Refresh failed',
    auto: 'Auto',
    manual: 'Manual',
    disableAutoRefresh: 'Disable auto-refresh',
    enableAutoRefresh: 'Enable auto-refresh (30s)',
    systemOverview: 'System Overview',
    uptime: 'Uptime',
    memory: 'Memory',
    dbLatency: 'DB Latency',
    serverTime: 'Server Time',
    activityToday: 'Activity Today',
    activeNations: 'Active Nations',
    requestsCreated: 'Requests Created',
    patients: 'Patients',
    missionsCreated: 'Missions Created',
    servicesStatus: 'Services Status',
    requestPipeline: 'Request Pipeline',
    noRequests: 'No requests',
    staleDrafts: 'Stale drafts (>24h)',
    reviewBottleneck: 'Review bottleneck (>48h)',
    publishedNoOffers: 'Published with no offers',
    dataConsistency: 'Data Consistency Checks',
    overallStatus: 'Overall Status',
    healthy: 'Healthy',
    warnings: 'Warnings',
    critical: 'Critical',
    check: 'Check',
    issues: 'Issues',
    noConsistencyChecks: 'No consistency checks available',
    databaseRecords: 'Database Records',
    exerciseStatus: 'Exercise Status',
    activeDay: 'Active Day',
    noActiveDay: 'No active day',
    templates: 'Templates',
    lastActivation: 'Last Activation',
    never: 'Never',
    recentAuditLog: 'Recent Audit Log',
    last10: 'Last 10',
    timestamp: 'Timestamp',
    user: 'User',
    action: 'Action',
    resource: 'Resource',
    noRecentAudit: 'No recent audit entries',
    justNow: 'just now',
    services: {
      database: 'Database',
      email: 'Email',
      sync: 'Sync',
      notifications: 'Notifications',
      maintenanceMode: 'Maintenance Mode',
      trainingMode: 'Training Mode',
      connectionFailed: 'Connection failed',
      enabledSmtp: 'Enabled & SMTP configured',
      enabledNoSmtp: 'Enabled but NO SMTP',
      disabled: 'Disabled',
      staleUnread: '{{count}} stale unread (>7d)',
      active: 'ACTIVE',
      off: 'Off',
    },
  },

  // ============================================================
  // PASSWORD COMPLEXITY
  // ============================================================
  passwordComplexity: {
    minLength: 'Vähintään 10 merkkiä',
    uppercase: '1 iso kirjain',
    lowercase: '1 pieni kirjain',
    digit: '1 numero',
    special: '1 erikoismerkki',
  },
};

export default fi;
